module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper services"
  }, [_c('h1', {
    staticClass: "services__page-title"
  }, [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _vm._l((_vm.services), function(service, index) {
    return _c('section', {
      staticClass: "service",
      class: {
        dark: (service.overview_text_color == 'Dark')
      },
      style: ({
        backgroundColor: service.overview_background_color,
        backgroundImage: 'url(' + service.native_video_fallback_image.url + ')'
      }),
      attrs: {
        "id": 's' + service.slug
      }
    }, [(service.native_video_mp4.url) ? _c('video', {
      staticClass: "service__video",
      attrs: {
        "autoplay": "",
        "muted": "",
        "loop": "",
        "playsinline": "",
        "poster": service.native_video_fallback_image.url
      },
      on: {
        "play": function($event) {
          _vm.handlePlay(service)
        }
      }
    }, [_c('source', {
      attrs: {
        "src": service.native_video_mp4.url,
        "type": "video/mp4"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "service__content",
      class: {
        dark: (service.overview_text_color == 'Dark')
      }
    }, [_c('h3', {
      staticClass: "service__title"
    }, [_c('router-link', {
      key: service.slug,
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(service.title) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(service.abstract)
      }
    })])]), _vm._v(" "), _c('a', {
      staticClass: "anchor-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.handleAnchor(_vm.nextService(index))
        }
      }
    })])
  }), _vm._v(" "), _c('section', {
    staticClass: "areas"
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.document.service_area_repeater), function(area) {
    return _c('div', {
      staticClass: "area"
    }, [_c('div', {
      staticClass: "area__icon"
    }, [_c('img', {
      attrs: {
        "src": area.icon.sizes.bandara_medium,
        "alt": area.icon.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "area__content"
    }, [_c('h3', [_vm._v(_vm._s(area.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(area.description)
      }
    })])])
  }))])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a765a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Services.vue
// module id = 264
// module chunks = 0